import { createConsumer } from "@rails/actioncable";
import { WEBSOCKET_URL } from "./constants";
const protocol = window.location.protocol.startsWith("https")
  ? "wss://"
  : "ws://";
export const consumer = createConsumer(protocol + WEBSOCKET_URL);
